var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"price-savings"},[(_vm.prefix)?_c('span',{staticClass:"price-savings__prefix"},[_vm._v(_vm._s(_vm.prefix)+" ")]):_vm._e(),_vm._v("\n\t"+_vm._s(_vm.savingsText)+"\n\t"),(_vm.suffix)?_c('span',{staticClass:"price-savings__suffix"},[_vm._v(" "+_vm._s(_vm.suffix))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }